import { encodedStringParser, numberParser, stringParser } from '../inboundParsers';
export const SHOW_PRIZE_WIN_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'winnerId', parser: numberParser },
        { name: 'winnerName', parser: stringParser },
        { name: 'messageToOthers', parser: encodedStringParser },
        { name: 'messageToWinner', parser: encodedStringParser },
        { name: 'prizeDescription', parser: encodedStringParser },
        { name: 'durationMs', parser: numberParser }
    ]
};
